export const environment = {
  production: true,
  BASE_URL: 'https://fxjxhv6l13.execute-api.eu-north-1.amazonaws.com',
};
